import { isDate, isMatch, getMonth, getYear, parse } from "date-fns";
import { useState, useEffect } from "react";
import { DATE_STRING_FORMAT } from "../Constants/stringFormats";

export default function useFiscalYear(initialValue, format) {
    const [fiscalYear, setFiscalYear] = useState(null);
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        const determinedFormat = format || DATE_STRING_FORMAT;

        let month = null;
        let year = null;
    
        if (isDate(value)) {
            month = getMonth(value);
            year = getYear(value);
        } else if (isMatch(value, determinedFormat)) {
            const parsedDate = parse(value, determinedFormat, new Date());
            
            month = getMonth(parsedDate);
            year = getYear(parsedDate);
        }
    
        if (month !== null && year !== null) {
            // runs from October through September
            if (month >= 0 && month <= 8) {
                setFiscalYear(year);
            }else  {
                setFiscalYear(year + 1);
            }
        } else {
            setFiscalYear(null);
        }
    }, [value]); 

    return [fiscalYear, setValue];
}